import type { IconData } from '@stacksjs/iconify-core'

export const minusCircleF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10M5 9a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default minusCircleF
